/**
 * Lightweight filter ID constants extracted from individual filter modules.
 *
 * These are simple string constants with zero transitive dependencies.
 * Use these instead of importing from the filter barrel file (index.tsx)
 * when you only need the filter ID for keying into a filters record.
 *
 * QS-9423: Breaking the dependency chain that dragged react-sweet-state
 * into the SSR bundle via filter barrel → filter controllers → search store.
 */

export const archivedFilterId = 'archived' as const;
export const archivedAndPendingComponentsFilterId = 'compassArchived' as const;
export const assetsSchemaFilterId = 'assetsSchema' as const;
export const assetsTypeFilterId = 'assetsType' as const;
export const assigneeFilterId = 'assignee' as const;
export const closeDateFilterId = 'closeDate' as const;
export const commentedByMeFilterId = 'commentedByMe' as const;
export const contentFilterId = 'content' as const;
export const contributorFilterId = 'contributor' as const;
export const createdByFilterId = 'createdBy' as const;
export const focusAreaTypeFilterId = 'focusAreaType' as const;
export const focusAreaUnderFilterId = 'focusAreaUnder' as const;
export const labelFilterId = 'label' as const;
export const lastUpdatedByFilterId = 'lastUpdatedBy' as const;
export const lastUpdatedFilterId = 'lastUpdated' as const;
export const campaignStatusFilterId = 'campaignStatus' as const;
export const caseStatusFilterId = 'caseStatus' as const;
export const opportunityStatusFilterId = 'opportunityStatus' as const;
export const pullRequestStatusFilterId = 'pullRequestStatus' as const;
export const repositoryFilterId = 'repository' as const;
export const ownerFilterId = 'owner' as const;
export const pageStatusFilterId = 'pageStatus' as const;
export const positionEmploymentTypeFilterId = 'positionEmploymentType' as const;
export const positionFocusAreaFilterId = 'positionFocusArea' as const;
export const positionJobFamilyFilterId = 'positionJobFamily' as const;
export const positionStatusFilterId = 'positionStatus' as const;
export const positionTeamFilterId = 'positionTeam' as const;
export const projectFilterId = 'project' as const;
export const reporterFilterId = 'reporter' as const;
export const salesforceStageFilterId = 'salesforceStage' as const;
export const sortFilterId = 'sort' as const;
export const spaceFilterId = 'space' as const;
export const statusFilterId = 'statusFilter' as const;
export const titleMatchFilterId = 'onlyTitleMatch' as const;
export const verifiedFilterId = 'verified' as const;
export const watchedFilterId = 'watchedByMe' as const;
export const slackChannelFilterId = 'slackChannel' as const;
export const folderFilterId = 'folder' as const;
export const workspaceNameFilterId = 'workspaceName' as const;
export const hasAttachmentFilterId = 'hasAttachment' as const;
